// types.js
export const LOGIN = 'login';

export const LOGOUT = 'logout';

export const states = {
  user:{
  "userid": "superadmin",
    "username": "",
    "password": "",
    "role": "admin",
    "device": ""
},
role:{
  "roleid": "admin",
    "rolename": "admin",
    "roleprivilege": "superPrivilege"
},
privMenu:{
  "device": true,
    "device_assign": true,
    "device_config": true,
    "device_list": true,
    "device_log": true,
    "device_status": true,
    "device_upgrade": true,
    "falutAnalysis": true,
    "management": true,
    "management_group": true,
    "management_model": true,
    "management_package": true,
    "management_parameter": true,
    "management_privilege": true,
    "management_route": true,
    "management_user": true,
    "monitor": true,
    "statistics": true,
    "task": true,
    "device_maintenance":true
},
account:'sysadmin'
}



// WEBPACK FOOTER //
// ./src/store/types.js